import type Dropzone from 'react-dropzone'

type DropzoneProps = React.ComponentProps<typeof Dropzone>

const APPLICATION_TYPES = [
  'application/pdf',
  'application/doc',
  'application/docx',
  'application/ms-doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
  'application/msword',
  'application/vnd.ms-excel.sheet.macroenabled.12',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.oasis.opendocument.spreadsheet',
  'application/xml',
  'application/vnd.oasis.opendocument.text',
  'application/vnd.oasis.opendocument.graphics',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.template',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
  'application/json',
  'application/x-yaml',
  'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
  'application/vnd.oasis.opendocument.presentation',
  'application/rtf',
  'application/msaccess',
  'application/vnd.ms-word.document.macroenabled.12',
  'application/vnd.ms-excel.sheet.binary.macroenabled.12',
  'application/vnd.ms-powerpoint.presentation.macroenabled.12',
  'application/vnd.ms-publisher',
  'application/vnd.ms-works',
  'application/vnd.ms-xpsdocument',
  'application/x-tika-msoffice',
  'application/oxps',
  'application/x-iwork-keynote-sffkey',
  'application/vnd.apple.pages',
  'application/vnd.apple.keynote',
  'application/vnd.apple.numbers',
  'application/x-adobe-indesign',
  'application/msonenote',
  'application/zip',
  'application/x-zip-compressed',
  'application/gzip',
]

const TEXT_TYPES = [
  'text/plain',
  'text/html',
  'text/xml',
  'text/markdown',
  'text/x-web-markdown',
  'text/vcard',
  'text/x-vcard',
  'text/csv',
  'text/comma-separated-values',
  'text/x-matlab',
]

const IMAGE_TYPES = [
  'image/jpeg',
  'image/png',
  'image/apng',
  'image/avif',
  'image/gif',
  'image/bmp',
  'image/tiff',
  'image/webp',
  'image/svg+xml',
  'image/heic',
  'image/emf',
  'image/vnd.adobe.photoshop',
  'image/vnd.microsoft.icon',
  'image/vnd.dwg',
  'image/jpx',
  'image/aces',
]

const VIDEO_TYPES = [
  'video/x-msvideo',
  'video/mp4',
  'video/mpeg',
  'video/webm',
  'video/3gpp',
  'video/quicktime',
  'video/x-ms-wmv',
]

const AUDIO_TYPES = [
  'audio/mpeg',
  'audio/amr',
  'audio/ogg',
  'audio/aac',
  'audio/wave',
  'audio/wav',
  'audio/x-wav',
  'audio/x-pn-wav',
  'audio/vnd.wave',
]

export const ACCEPTED_CONTENT_TYPES = [
  ...APPLICATION_TYPES,
  ...TEXT_TYPES,
  ...IMAGE_TYPES,
  ...VIDEO_TYPES,
  ...AUDIO_TYPES,
]

export function acceptedContentTypes(contentTypes = ACCEPTED_CONTENT_TYPES) {
  return contentTypes.reduce<NonNullable<DropzoneProps['accept']>>((acc, value) => {
    acc[value] = []

    return acc
  }, {})
}
